import { useEffect, useState } from 'react';
import { api } from '../services/api';
import type { CurrencyOut } from '../types/api';

const EUR_ONLY: CurrencyOut[] = [{ code: 'EUR', rate: '1', on_sale: true, fixed: true, updated_at: null }];

/** The currencies staff set on the Prices page (`GET /admin/currencies`, EUR first). EUR alone while they load or
 *  when they cannot be read, so a picker always has the ledger's currency. */
export function useCurrencies(): CurrencyOut[] {
  const [list, setList] = useState<CurrencyOut[]>(EUR_ONLY);
  useEffect(() => {
    let live = true;
    api.currencies().then(
      (rows) => live && rows.length > 0 && setList(rows),
      () => undefined,
    );
    return () => {
      live = false;
    };
  }, []);
  return list;
}

/** The codes an offer or a pack can be created in: every currency with a rate (the API refuses one without). */
export function useRatedCurrencyCodes(): string[] {
  return useCurrencies().map((c) => c.code);
}

/** The codes an organization can be moved to: those on sale, plus its current one. */
export function useOrgCurrencyCodes(current: string): string[] {
  const onSale = useCurrencies()
    .filter((c) => c.on_sale)
    .map((c) => c.code);
  return onSale.includes(current) ? onSale : [current, ...onSale];
}
